const formatCsvField = (value: string) => /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;

/** CSV text from rows of fields, quoting the fields that need it. */
export const formatCsv = (rows: string[][]) => rows.map(row => row.map(formatCsvField).join(',')).join('\n') + '\n';
